import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingSection = () => {
  return /*#__PURE__*/_jsx("div", {
    style: {
      height: 200
    },
    children: /*#__PURE__*/_jsx(LoadingSpinner, {
      layout: "centered"
    })
  });
};
export default LoadingSection;